/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineContainer } from './vue-component-lib/utils';

import type { JSX } from '@ovhcloud/ods-stencil/components/skeleton/custom-elements';

import { defineCustomElement as defineOsdsSkeleton } from '@ovhcloud/ods-stencil/components/skeleton/custom-elements/osds-skeleton.js';


export const OsdsSkeleton = /*@__PURE__*/ defineContainer<JSX.OsdsSkeleton>('osds-skeleton', defineOsdsSkeleton, [
  'flex',
  'randomized',
  'size'
]);

